module.exports = __webpack_public_path__ + "static/img/weezie_icon.a5dc9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_icon.png
// module id = kyn+
// module chunks = 0